// frontend/src/services/analysisSession.ts
// sessionStorage helpers for the Video Analysis page.
// State persists for the lifetime of the browser tab and is cleared on close.

const STATE_KEY = 'videoAnalysisState';
const QUEUE_KEY = 'videoAnalysisQueue';

export interface SlotState {
  id: string;
  key: string | null;
  speedOverride: number | null;
}

export interface AnalysisState {
  slots: SlotState[];
  columns: number;
  syncEnabled: boolean;
  globalSpeed: number;
}

const DEFAULT_STATE: AnalysisState = {
  slots: [{ id: crypto.randomUUID(), key: null, speedOverride: null }],
  columns: 2,
  syncEnabled: false,
  globalSpeed: 1,
};

export function loadAnalysisState(): AnalysisState {
  try {
    const raw = sessionStorage.getItem(STATE_KEY);
    if (!raw) return { ...DEFAULT_STATE, slots: [{ id: crypto.randomUUID(), key: null, speedOverride: null }] };
    return JSON.parse(raw) as AnalysisState;
  } catch {
    return { ...DEFAULT_STATE, slots: [{ id: crypto.randomUUID(), key: null, speedOverride: null }] };
  }
}

export function saveAnalysisState(state: AnalysisState): void {
  try {
    sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
  } catch {
    // Silently ignore quota errors
  }
}

export function enqueueVideoForAnalysis(key: string): void {
  try {
    sessionStorage.setItem(QUEUE_KEY, JSON.stringify({ key }));
  } catch {
    // Silently ignore
  }
}

export function consumeAnalysisQueue(): string | null {
  try {
    const raw = sessionStorage.getItem(QUEUE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(QUEUE_KEY);
    const parsed = JSON.parse(raw) as { key: string };
    return parsed.key ?? null;
  } catch {
    return null;
  }
}
